import { UnionBoxesNode_2 } from '../types/graphql-types';

export const getBoxBackground = (item: UnionBoxesNode_2) =>
  (item && (item as any).color) || undefined;
